import { useQueryClient } from 'react-query';
import { useLikeAdaptedFictionEditionComment } from '../../../domains/scene/ui/hooks/useLikeAdaptedFictionEditionComment';
import { useFollowUser } from '../../../domains/user/ui/hooks/useFollowUser';
import { useGetUserInfo } from '../../../domains/user/ui/hooks/useGetUserInfo';
import { SCENE_QUERY_KEYS } from '../../../domains/scene/ui/queryKeys';

interface UseManageCommentBottomSheetProps {
  adaptedFictionEditionId: string;
  commentId: string;
}

export const useManageCommentBottomSheet = ({
  adaptedFictionEditionId,
  commentId
}: UseManageCommentBottomSheetProps) => {
  const { mutateAsync: likeAdaptedFictionEditionComment } = useLikeAdaptedFictionEditionComment({
    adaptedFictionEditionId,
    commentId: commentId
  });
  const { mutateAsync: followUser } = useFollowUser();
  const { data: user } = useGetUserInfo();
  const queryClient = useQueryClient();

  const handleLikeComment = async () => {
    try {
      const response = await likeAdaptedFictionEditionComment();
      if (!response?.commentId) {
        throw new Error('Failed to like adapted fiction edition comment');
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleFollowUser = async (userProfileId: string) => {
    if (!user?.baseUserProfile?.userProfileId || !userProfileId) return;
    try {
      await followUser({
        myProfileId: user?.baseUserProfile?.userProfileId,
        userProfileId: userProfileId
      });

      queryClient.invalidateQueries(
        SCENE_QUERY_KEYS.adaptedFictionEditionComments(adaptedFictionEditionId)
      );
    } catch (error) {
      console.error(error);
    }
  };

  return {
    handleLikeComment,
    handleFollowUser
  };
};
